import React from 'react';

import classNames from 'classnames';

import s from './greeting.scss';

type PropsType = {
    underline?: boolean;
    children: React.ReactNode;
};

/**
 * Title with magic flares
 * @param {PropsType} props - Props of component
 * @returns {React.ReactElement} component
 */
export const Greeting: React.FC<PropsType> = ({children, underline = false}) => (
    <div className={classNames(s.wrapper, {[s.underline]: underline})}>
        <h1 className={s.greet}>{children}</h1>
    </div>
);
